import { useEffect, useState } from "react";
import {
    DefaultApi,
    HTTPValidationError,
    JobApplication,
    JobPosition,
    JobPositionPreview,
    Language,
} from "../adapters/api";
import { useTranslation } from "react-i18next";

export const usePosition = (positionId?: number) => {
    const defaultApi = new DefaultApi();
    const { t, i18n } = useTranslation();

    const [positions, setPositions] = useState<JobPositionPreview[]>([]);
    const [position, setPosition] = useState<JobPosition>();

    const getPositions = async (): Promise<JobPositionPreview[]> =>
        new Promise((resolve, reject) => {
            defaultApi
                .getPositions(i18n.resolvedLanguage as Language)
                .then((response) => {
                    const { data } = response;
                    setPositions(data);
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });

    const getPositionById = async (posId: number): Promise<JobPosition> =>
        new Promise((resolve, reject) => {
            defaultApi
                .getPosition(posId, i18n.resolvedLanguage as Language)
                .then((response) => {
                    const { data } = response;
                    setPosition(data);
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });

    const postPositionApply = async (
        jobApplication: JobApplication
    ): Promise<HTTPValidationError> =>
        new Promise((resolve, reject) => {
            defaultApi
                .applyToPosition(jobApplication)
                .then((response) => {
                    const { data } = response;
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });

    useEffect(() => {
        if (positionId) {
            getPositionById(positionId);
        } else {
            getPositions();
        }
        // eslint-disable-next-line
    }, [t]);

    return {
        getPositions,
        getPositionById,
        postPositionApply,
        positions,
        position,
    };
};
